import { render, staticRenderFns } from "./BattleBox.vue?vue&type=template&id=43d1c62d&"
import script from "./BattleBox.vue?vue&type=script&lang=ts&"
export * from "./BattleBox.vue?vue&type=script&lang=ts&"
import style0 from "./BattleBox.vue?vue&type=style&index=0&id=43d1c62d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports